import React, { FC } from 'react'

interface ReadonlyTextProps {
  value: string
  unit?: string
  className?: string
}

export const ReadonlyText: FC<ReadonlyTextProps> = ({
  value,
  unit,
  className = ''
}) => {
  return (
    <div className={`flex justify-start ${className}`}>
      <p>{value}</p>
      {unit && (
        <div className="flex flex-col justify-center">
          <p className="pl-1 whitespace-nowrap">{unit}</p>
        </div>
      )}
    </div>
  )
}